import { render, staticRenderFns } from "./DetalharIrmao.vue?vue&type=template&id=64d0cd62"
import script from "./DetalharIrmao.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetalharIrmao.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports